import { ContactCreditType } from "@/gql/graphql";
import { BadgeColor } from "@/components/catalyst/badge";

export const contactCreditTypeColorMap: {
  [key in ContactCreditType]: BadgeColor;
} = {
  [ContactCreditType.Issued]: "green",
  [ContactCreditType.Applied]: "yellow",
  [ContactCreditType.Reversed]: "red",
};
